import { ajaxSend, formatDate } from '../utils';
const showTime = (dateString) => {
    if (!dateString) {
        return;
    }
    const date = new Date(dateString);
    if (!date) {
        console.log('Дата не получена');
        return;
    }
    const selectedDate = formatDate(date);
    const errorBlock = document.querySelector('.appointment__form__datepicker');
    errorBlock && errorBlock.classList.remove('error');
    const timeWrapper = document.querySelector('.appointment__time-choice');
    const timeList = document.querySelectorAll('.appointment__time-choice__time');
    const timeInput = document.querySelector('input[name = "time"]');
    const anonsFirst = document.querySelector('.appointment__time-choice__anonsment.first');
    const anonsEmpty = document.querySelector('.appointment__time-choice__anonsment.empty');
    if (!timeList) {
        console.log('Нет блока со временем');
        return;
    }
    timeList.forEach(item => {
        item.addEventListener('click', () => {
            unActiveAllTime(timeList);
            item.classList.add('active');
            timeInput.value = item.dataset.time;
            timeWrapper.classList.remove('error');
        });
    });
    const url = '/udata/appointment/getAppointmentsData/';
    const responseFormat = 'json';
    ajaxSend({ url, responseFormat })
        .then((response) => {
        dataHandler(response);
    })
        .catch((err) => {
        console.error(err);
    });
    const dataHandler = (data) => {
        const dayOfWeek = date && date.getDay();
        if ((dayOfWeek == 0) || (dayOfWeek == 6)) {
            hideAllTime(timeList);
            return;
        }
        anonsFirst.classList.add('hide');
        const entry = data.entry.complete_booked && data.entry.complete_booked[selectedDate];
        showAllTime(timeList);
        unActiveAllTime(timeList);
        entry && hideTime(entry, timeList);
    };
    const showAllTime = (timeList) => {
        timeList.forEach(time => {
            time.classList.remove('hide');
        });
        anonsEmpty.classList.add('hide');
    };
    const hideAllTime = (timeList) => {
        timeList.forEach(time => {
            time.classList.add('hide');
            time.classList.remove('active');
        });
        timeInput.value = '';
        anonsEmpty.classList.remove('hide');
    };
    const unActiveAllTime = (timeList) => {
        timeList.forEach(time => {
            time.classList.remove('active');
        });
        timeInput.value = '';
    };
    const hideTime = (entry, timeList) => {
        entry && entry.forEach((appoint) => {
            timeList.forEach(time => {
                if (time.dataset.time == appoint.time) {
                    time.classList.add('hide');
                }
            });
        });
    };
};
export default showTime;
